export const ReportSecurityType = {
    PowerBI: 1,
    PaginatedReport: 2,
    NoSecurity: 3
};
